import { IStore } from "helpers";
import { createSlice } from "@reduxjs/toolkit";

export const reportReducer = createSlice({
  name: "report store",
  initialState: {
    listSite: [],
    hasNotYetSupplied: false,
  },
  reducers: {
    setListSiteAvailable: (state, action) => {
      state.listSite = action.payload;
    },
    setHasNotYetSupplied: (state,action) => {
      state.hasNotYetSupplied = action.payload
    }
  },
});
export const { setListSiteAvailable, setHasNotYetSupplied } = reportReducer.actions;

export const getListSiteAvailable = (state: IStore) => state.report.listSite;
export const getHasNotYetSupplied = (state: IStore) => state.report.hasNotYetSupplied;

export default reportReducer.reducer;
